import { BASEURL } from "../../../constant";
import { todoTextUpdated } from "../actions";

const updateTodo = (todoText, todoId) => {
  return async (dispatch) => {
    try {
      const response = await fetch(BASEURL + "/todos/" + todoId, {
        method: "PATCH",
        body: JSON.stringify({
          text: todoText,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      const todo = await response.json();
      if (todo) {
        dispatch(todoTextUpdated(todo));
      } else alert("Please Try again");
    } catch (error) {
      console.log("error: ", { error });
      alert("Please Try again");
    }
  };
};

export default updateTodo;
